module.exports = __webpack_public_path__ + "img/edit.ce0122a4.png";